import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Controller } from 'react-hook-form';

import { useCalendarSettingsLogic } from 'modules/calendarv2/hooks/useCalendarSettingsLogic';
// import { BUSINESS_HOURS_OPTIONS } from 'modules/calendarv2/constants/businessHours';
import { VIEW_OPTIONS } from 'modules/calendarv2/constants/calendarViews';

const CalendarSettings = () => {
  const {
    form,
    errors,
    isDirty,
    isValid,
    // showBusinessTimeOnly,
    // outlookEmail,
    googleEmail,
    googleCalendars,
    isLoadingCalendars,
    isUpdating,
    isConnectingGoogle,
    isDisconnectingGoogle,
    // isConnectingOutlook,
    isOpen,
    handleSave,
    handleGoogleConnect,
    handleGoogleDisconnect,
    // handleOutlookConnect,
    // handleOutlookDisconnect,
    closeSettingsModal,
  } = useCalendarSettingsLogic();

  const { control, watch } = form;
  const selectedCalendarId = watch('calendar_id');

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="calendar-settings-backdrop" onClick={closeSettingsModal} />

      {/* Sidebar */}
      <div className={`calendar-settings-sidebar ${isOpen ? 'open' : ''}`}>
        {/* Header */}
        <div className="settings-sidebar-header">
          <h3>Calendar Settings</h3>
          <Button icon="pi pi-times" className="p-button-text" onClick={closeSettingsModal} rounded text aria-label="Close" />
        </div>

        {/* Content */}
        <div className="settings-sidebar-content">
          <div className="settings-group">
            <h4 className="settings-group-title">Display Options</h4>

            <div className="setting-item">
              <label>Show Weekends</label>
              <Controller name="show_weekends" control={control} render={({ field }) => <InputSwitch {...field} checked={field.value} />} />
            </div>

            <div className="setting-item">
              <label>Show Birthdays</label>
              <Controller
                name="show_birthdays"
                control={control}
                render={({ field }) => <InputSwitch {...field} checked={field.value} />}
              />
            </div>

            <div className="setting-item">
              <label>Show SOL (Statute of Limitations)</label>
              <Controller name="show_sol" control={control} render={({ field }) => <InputSwitch {...field} checked={field.value} />} />
            </div>
          </div>

          <div className="settings-group">
            <h4 className="settings-group-title">Business Hours</h4>

            <div className="setting-item">
              <label>Show Business Time Only</label>
              <Controller
                name="show_business_times_only"
                control={control}
                render={({ field }) => <InputSwitch {...field} checked={field.value} />}
              />
            </div>

            {/* {showBusinessTimeOnly && (
              <>
                <div className="setting-item">
                  <label>Business Hours Start</label>
                  <Controller
                    name="business_start_time"
                    control={control}
                    render={({ field }) => (
                      <Dropdown
                        {...field}
                        inputRef={field.ref}
                        options={BUSINESS_HOURS_OPTIONS}
                        style={{ width: '100%' }}
                        className={errors.business_start_time ? 'p-invalid' : ''}
                      />
                    )}
                  />
                  {errors.business_start_time && <small className="p-error">{errors.business_start_time.message}</small>}
                </div>

                <div className="setting-item">
                  <label>Business Hours End</label>
                  <Controller
                    name="business_end_time"
                    control={control}
                    render={({ field }) => (
                      <Dropdown
                        {...field}
                        inputRef={field.ref}
                        options={BUSINESS_HOURS_OPTIONS}
                        style={{ width: '100%' }}
                        className={errors.business_end_time ? 'p-invalid' : ''}
                      />
                    )}
                  />
                  {errors.business_end_time && <small className="p-error">{errors.business_end_time.message}</small>}
                </div>
              </>
            )} */}
          </div>

          <div className="settings-group">
            <h4 className="settings-group-title">Synchronization</h4>
            {/* to do: add synchronization with outlook */}
            {/* <div className="setting-item sync-item">
              <div className="sync-header">
                <label>Sync with Outlook</label>
              </div>
              {outlookEmail ? (
                <div className="sync-status connected">
                  <div className="connection-info">
                    <i className="pi pi-check-circle"></i>
                    <span>{outlookEmail}</span>
                  </div>
                  <Button label="Disconnect" className="disconnect-btn" onClick={handleOutlookDisconnect} />
                </div>
              ) : (
                <div className="sync-status not-connected">
                  <Button
                    label={isConnectingOutlook ? 'Connecting...' : 'Connect Outlook'}
                    icon={isConnectingOutlook ? 'pi pi-spin pi-spinner' : 'pi pi-microsoft'}
                    className="connect-btn"
                    onClick={handleOutlookConnect}
                    disabled={isConnectingOutlook}
                  />
                </div>
              )}
            </div> */}

            <div className="setting-item sync-item">
              <div className="sync-header">
                <label>Sync with Google Calendar</label>
              </div>
              {googleEmail ? (
                <>
                  <div className="sync-status connected">
                    <div className="connection-info">
                      <i className="pi pi-google"></i>
                      <span>Connected to Google Calendar</span>
                    </div>
                    <Button
                      label={isDisconnectingGoogle ? 'Disconnecting...' : 'Disconnect'}
                      icon={isDisconnectingGoogle ? 'pi pi-spin pi-spinner' : ''}
                      className="disconnect-btn"
                      onClick={handleGoogleDisconnect}
                      disabled={isDisconnectingGoogle}
                    />
                  </div>

                  {googleEmail && (
                    <>
                      <div className="setting-item mt-2">
                        <label>Select Google Calendar</label>
                        <Controller
                          name="calendar_id"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              {...field}
                              options={googleCalendars}
                              optionLabel="label"
                              optionValue="value"
                              placeholder={isLoadingCalendars ? 'Loading calendars...' : 'Select a calendar'}
                              style={{ width: '100%' }}
                              disabled={isLoadingCalendars}
                              className={errors.calendar_id ? 'p-invalid' : ''}
                            />
                          )}
                        />
                        {errors.calendar_id && <small className="p-error">{errors.calendar_id.message}</small>}
                      </div>
                      {!selectedCalendarId && (
                        <small className="text-muted d-block mt-1" style={{ fontSize: '0.875rem' }}>
                          <i className="pi pi-info-circle me-1"></i>
                          By default, primary google calendar will be displayed.
                        </small>
                      )}
                    </>
                  )}
                </>
              ) : (
                <div className="sync-status not-connected">
                  <Button
                    label={isConnectingGoogle ? 'Connecting...' : 'Connect Google'}
                    icon={isConnectingGoogle ? 'pi pi-spin pi-spinner' : 'pi pi-google'}
                    className="connect-btn"
                    onClick={handleGoogleConnect}
                    disabled={isConnectingGoogle}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="settings-group">
            <h4 className="settings-group-title">Default View</h4>

            <div className="setting-item w-100">
              <label>Default Calendar View</label>
              <Controller
                name="default_calendar_view"
                control={control}
                render={({ field }) => (
                  <Dropdown
                    {...field}
                    options={VIEW_OPTIONS}
                    style={{ width: '100%' }}
                    className={errors.default_calendar_view ? 'p-invalid' : ''}
                  />
                )}
              />
              {errors.default_calendar_view && <small className="p-error">{errors.default_calendar_view.message}</small>}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="settings-sidebar-footer">
          <Button
            label="Cancel"
            onClick={closeSettingsModal}
            className="p-button p-button-secondary outline"
            disabled={isUpdating}
            style={{ flex: 1 }}
          />
          <Button
            label={isUpdating ? 'Saving...' : 'Save Changes'}
            onClick={handleSave}
            className="p-button p-button-secondary"
            disabled={isUpdating || !isDirty || !isValid}
            icon={isUpdating ? 'pi pi-spin pi-spinner' : ''}
            style={{ flex: 1 }}
          />
        </div>
      </div>
    </>
  );
};

export default CalendarSettings;
